import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, interval, switchMap } from "rxjs";
import { environment } from "@environment";

export const TOAST_STATE = {
  success: 'success-toast',
  warning: 'warning-toast',
  danger: 'danger-toast'
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  public showsToast$ = new BehaviorSubject(false);
  public toastMessage$ = new BehaviorSubject('');
  public toastState$ = new BehaviorSubject(TOAST_STATE.success);

  constructor() {
    this.showsToast$.pipe(
      switchMap(value => value ? interval(environment.toastDurationTime) : EMPTY)
    ).subscribe(() => this.dismissToast());
  }

  showToast(toastState:string, toastMsg: string) {
    this.toastMessage$.next(toastMsg);
    this.toastState$.next(toastState);
    this.showsToast$.next(true);
  }

  dismissToast() {
    this.showsToast$.next(false);
  }
}
